<template>
  <div class="grid grid-cols-6 items-start gap-6">
    <div class="col-span-3">
      <label class="mb-1 block text-sm font-medium text-gray-700">{{
        t('site.active')
      }}</label>
      <Toggle
        srLabel="Site"
        :checked="siteStore.site.active"
        :onToggle="onToggle"
      />
    </div>
    <div
      v-if="!siteStore.isLoading && siteStore.site.id !== 'new'"
      class="col-span-3 flex justify-end"
    >
      <a
        v-if="siteStore.storyblokLink"
        class="inline-flex items-center rounded-sm border border-[#09B3AF] bg-white px-2 py-1 text-xs font-medium text-[#09B3AF] hover:bg-[#09B3AF] hover:text-white focus:ring-2 focus:ring-[#09B3AF] focus:ring-offset-2 focus:outline-hidden"
        target="_blank"
        :href="siteStore.storyblokLink"
        ><svg
          class="mt-0.5 mr-2 h-6 w-6 self-start fill-current"
          viewBox="0 0 87 103"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          aria-label="Storyblok logo"
        >
          <g id="storyblok-logo" fill-rule="nonzero">
            <g>
              <path
                d="M51.8,49 L31,49 L31,59 L51.3,59 C52.5,59 53.6,58.5 54.5,57.7 C55.3,56.9 55.8,55.7 55.8,54.2 C55.8290035,52.9130708 55.4433501,51.6509323 54.7,50.6 C53.9,49.6 53,49 51.8,49 Z M52.5,36.9 C53.4,36.3 53.8,35 53.8,33.3 C53.8,31.8 53.4,30.7 52.7,30 C52,29.4 51.1,29 50.1,29 L31,29 L31,38 L49.7,38 C50.7,38 51.7,37.5 52.5,36.9 Z"
              />
              <path
                d="M83,0 L4.5,0 C2,0 0,2 0,4.4 L0,83 C0,85.4 2,86.9 4.4,86.9 L16,86.9 L16,102.6 L30.4,87 L83,87 C85.4,87 86.9,85.5 86.9,83 L86.9,4.5 C86.9,2.1 85.4,0.1 82.9,0.1 L83,0 Z M69.8,63.7 C68.8,65.5 67.3,67 65.5,68.1 C63.6,69.3 61.5,70.4 59.1,70.9 C56.7,71.5 54.1,72 51.4,72 L16,72 L16,16 L56.2,16 C58.2,16 59.9,16.4 61.5,17.3 C63,18.1 64.4,19.2 65.5,20.5 C67.7403434,23.2320077 68.9444137,26.6671496 68.9,30.2 C68.9,32.8 68.2,35.3 66.9,37.7 C65.5522265,40.1140117 63.4421536,42.0130773 60.9,43.1 C64.1,44 66.6,45.6 68.5,47.9 C70.3,50.3 71.2,53.4 71.2,57.3 C71.2,59.8 70.7,61.9 69.7,63.7 L69.8,63.7 Z"
              />
            </g>
          </g>
        </svg>
        {{ t('storyblokPages.view') }}</a
      >
      <a
        v-else
        class="inline-flex items-center rounded-sm border border-violet-500 bg-white px-2 py-1 text-xs font-medium text-violet-500 hover:bg-violet-500 hover:text-white focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 focus:outline-hidden"
        target="_blank"
        :href="siteGeneratorLink"
      >
        <svg
          class="mr-2 h-6 w-6 self-start fill-current"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            d="M22 18c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092C20.1 22 19.4 22 18 22s-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.092-1.092C14 20.1 14 19.4 14 18s0-2.1.273-2.635a2.5 2.5 0 0 1 1.092-1.092C15.9 14 16.6 14 18 14s2.1 0 2.635.273a2.5 2.5 0 0 1 1.092 1.092C22 15.9 22 16.6 22 18Zm0-8c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092C20.1 14 19.4 14 18 14s-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.092-1.092C14 12.1 14 11.4 14 10s0-2.1.273-2.635a2.5 2.5 0 0 1 1.092-1.093C15.9 6 16.6 6 18 6s2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093C22 7.9 22 8.6 22 10Zm-8 8c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092C12.1 22 11.4 22 10 22s-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092C6 20.1 6 19.4 6 18s0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.092C7.9 14 8.6 14 10 14s2.1 0 2.635.273a2.5 2.5 0 0 1 1.092 1.092C14 15.9 14 16.6 14 18ZM10 6c0 1.4 0 2.1-.272 2.635a2.5 2.5 0 0 1-1.093 1.093C8.1 10 7.4 10 6 10s-2.1 0-2.635-.272a2.5 2.5 0 0 1-1.093-1.093C2 8.1 2 7.4 2 6s0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.093C3.9 2 4.6 2 6 2s2.1 0 2.635.272a2.5 2.5 0 0 1 1.093 1.093C10 3.9 10 4.6 10 6Z"
          />
        </svg>
        Create site in Storyblok</a
      >
    </div>
    <div class="col-span-6">
      <FormInput
        id="siteName"
        type="text"
        :value="siteStore.site.name"
        :label="t('site.name') + '*'"
        :onInput="updateName"
        :rules="nameRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="siteUrl"
        type="text"
        :value="siteStore.site.siteUrl"
        :label="t('site.siteUrl')"
        :onInput="updateSiteUrl"
        :rules="siteUrlRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="siteSlug"
        type="text"
        :value="siteStore.site.siteSlug"
        :label="t('site.siteSlug')"
        :onInput="updateSiteSlug"
        :rules="siteSlugRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="vacancyLinkFormat"
        type="text"
        :value="siteStore.site.vacancyLinkFormat"
        :label="t('site.vacancyLinkFormat')"
        :onInput="updateVacancyLinkFormat"
        :rules="vacancyLinkFormatRules"
        :helpPopoverText="`You can use field replacements like {{vacancy.title}}. {{vacancy.applicationUrl}} or {{vacancy.company.slug}}. All vacancy and company fields are available, use snakeCase for the field names`"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="companyLinkFormat"
        type="text"
        :value="siteStore.site.companyLinkFormat"
        :label="t('site.companyLinkFormat')"
        :onInput="updateCompanyLinkFormat"
        :rules="companyLinkFormatRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="code"
        type="text"
        :value="siteStore.site.code"
        :label="t('site.code') + '*'"
        :onInput="updateCode"
        :rules="codeRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="token"
        type="text"
        :value="siteStore.site.token"
        :label="t('site.token') + '*'"
        :onInput="updateToken"
        :rules="tokenRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="storyblokToken"
        type="text"
        :value="siteStore.site.storyblokToken"
        :label="t('site.storyblokToken')"
        :helpPopoverText="t('site.storyblokTokenHelpText')"
        :onInput="updateStoryblokToken"
        :rules="{}"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="gtmId"
        type="text"
        :value="siteStore.site.googleTagManagerId"
        :label="t('site.googleTagManagerId')"
        :helpPopoverText="t('site.googleTagManagerHelpText')"
        :onInput="updateGtmId"
        :rules="gtmIdRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="daysExpiredVacancyVisible"
        type="number"
        :value="siteStore.site.daysExpiredVacancyVisible"
        :label="t('site.daysExpiredVacancyVisible')"
        :onInput="updateDaysExpiredVacancyVisible"
        :rules="daysExpiredVacancyVisibleRules"
      />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useSiteStore } from '../../store/siteStore'
import { required, helpers, url } from '@vuelidate/validators'
import FormInput from '../FormInput.vue'
import Toggle from '../Toggle.vue'
import toKebabCase from 'lodash.kebabcase'
import { computed } from 'vue'

const siteStore = useSiteStore()

const trimProtocol = (url) => url.replace(/https?:\/\//, '')

const baseVacancyLinkFormat = '/{{vacancy.id}}/{{vacancy.slug}}'
const baseCompanyLinkFormat = '/{{company.slug}}'

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})

const siteGeneratorLink = computed(() => {
  if (siteStore.site.id !== 'new') {
    return `${import.meta.env.VITE_SITE_GENERATOR_URL}/${siteStore.site.siteSlug}`
  }
  return ''
})

const nameRules = {
  required: helpers.withMessage(t('validations.siteName.required'), required),
  $autoDirty: true,
}
const updateName = (newName) => {
  siteStore.site.name = newName
}

const onToggle = () => {
  siteStore.site.active = !siteStore.site.active
}

const siteSlugRules = {
  $autoDirty: true,
}

const updateSiteSlug = (newSlug) => {
  siteStore.site.siteSlug = newSlug
}

const siteUrlRules = {
  url: helpers.withMessage(t('validations.siteUrl.url'), url),
  $autoDirty: true,
}
const updateSiteUrl = (newUrl) => {
  siteStore.site.siteSlug = toKebabCase(trimProtocol(newUrl))
  siteStore.site.vacancyLinkFormat = `${newUrl}${baseVacancyLinkFormat}`
  siteStore.site.companyLinkFormat = `${newUrl}${baseCompanyLinkFormat}`
  siteStore.site.siteUrl = newUrl
}

const vacancyLinkFormatRules = {
  $autoDirty: true,
}

const updateVacancyLinkFormat = (value) => {
  siteStore.site.vacancyLinkFormat = value
}

const companyLinkFormatRules = {
  $autoDirty: true,
}

const updateCompanyLinkFormat = (value) => {
  siteStore.site.companyLinkFormat = value
}

const codeRules = {
  required: helpers.withMessage(t('validations.siteCode.required'), required),
  $autoDirty: true,
}

const gtmIdRules = {
  $autoDirty: true,
}

const updateCode = (value) => {
  siteStore.site.code = value
}

const updateGtmId = (value) => {
  siteStore.site.googleTagManagerId = value
}

const tokenRules = {
  required: helpers.withMessage(t('validations.siteToken.required'), required),
  $autoDirty: true,
}

const updateToken = (value) => {
  siteStore.site.token = value
}

const updateStoryblokToken = (value) => {
  siteStore.site.storyblokToken = value
}

const daysExpiredVacancyVisibleRules = {
  $autoDirty: true,
}

const updateDaysExpiredVacancyVisible = (value) => {
  siteStore.site.daysExpiredVacancyVisible = value
}
</script>
